import React, { useState } from "react";
import { faqs } from "../constants";
import styles from "../style";

const FAQ = () => {

  const [openIndex, setOpenIndex] = useState(null);
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };


  return (
    <section id="faq">
      <div className="text-center my-4">
        <h2 className={styles.heading2}>FAQ's</h2>
      </div>
      <div className="grid sm:grid-cols-2 grid-cols-1 gap-4 w-full mx-auto my-10">
      {faqs.map((faq, index) => (
        <div key={index} className="rounded-lg overflow-hidden">
          <div
            onClick={() => toggleFAQ(index)}
            className="px-3 sm:px-4 py-3 sm:py-4 bg-slate-900 cursor-pointer flex justify-between items-start sm:items-center"
          >
            <p className="text-white font-semibold" style={{fontSize: '16px', fontFamily: 'Inter, ui-sans-serif, sans-serif', margin: 0}}>{faq.question}</p>
            <span className="text-white text-lg sm:text-xl ml-2">{openIndex === index ? '-' : '+'}</span>
          </div>
          {openIndex === index && (
            <div className="px-3 sm:px-4 py-3 sm:py-3 bg-slate-900">
              <p className="text-white" style={{fontSize: '14px', fontFamily: 'Inter, ui-sans-serif, sans-serif', margin: 0}}>{faq.answer}</p>
            </div>
          )}
        </div>
      ))}
    </div>
    </section>
  );
};

export default FAQ;
